import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../../user/selectors'
import { getPcrIdSelector } from '../../../../home/selectors'
import { PcrDocsService } from '../../../../../services/pcrDocs.service'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { getGlassgowCommaScoreSelector } from '../selectors'
import { getSelectedDataFromObject } from '../../../../../utilities/data.util'
import { IGlassgowCommaScoreState } from '../store/glassgowCommaScore.types'
import { GlassgowCommaScoreConstants } from '../store/glassgowCommaScore.constants'
import {
  gcsPlaceholders,
  glassgowCommaScorePrGcsQualifier,
  glassgowCommaScorePrNabc,
} from '../store/glassgowCommaScore.reducers'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* saveGlassgowCommaScore() {
  const glassgowCommaScoreData: IGlassgowCommaScoreState = yield select(getGlassgowCommaScoreSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

    const prNabcKeys: any = Object.keys(glassgowCommaScorePrNabc)
    const prNabcData = getSelectedDataFromObject(glassgowCommaScoreData, prNabcKeys)

    const prGCSQualifierKeys: any = Object.keys(glassgowCommaScorePrGcsQualifier)
    const prGcsQualifier: any = getSelectedDataFromObject(glassgowCommaScoreData, prGCSQualifierKeys)

    const gcsPlaceHolderKeys: any = Object.keys(gcsPlaceholders)
    const gcsPlaceHolderData: any = getSelectedDataFromObject(glassgowCommaScoreData, gcsPlaceHolderKeys)

    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      prNabc: {
        ...pcrDoc.prNabc,
        ...prNabcData,
      },
      prGcsQualifier: !prGcsQualifier.qualifierPNNV ? prGcsQualifier.qualifier : [],
      prGcsQualifierPNNV: prGcsQualifier.qualifier.length === 0 ? prGcsQualifier.qualifierPNNV : null,
      _uiPlaceHolder: { ...pcrDoc._uiPlaceHolder, gcsPlaceholders: { ...gcsPlaceHolderData } },
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveGlassgowCommaScore() error: ${e}`))
    }
  }
}

export function* saveGlassgowCommaScoreSaga() {
  yield takeLatest(
    [
      GlassgowCommaScoreConstants.SAVE_GLASSGOW_COMMA_SCORE,
      GlassgowCommaScoreConstants.SET_QUALIFIER,
      GlassgowCommaScoreConstants.SET_QUALIFIER_PNNV,
    ],
    performWithMutexHOG,
    saveGlassgowCommaScore
  )
}
